import React, { FC } from "react";
import Section from "../../components/section";
import { PageHero } from "../../components/page-hero";
import Layout from "../../components/layout/layout";
import automaticAi_1 from '../../images/monitoringScreens/automatic-ai_1.jpg';
import automaticAi_2 from '../../images/monitoringScreens/automatic-ai_2.jpg';
import automaticAi_3 from '../../images/monitoringScreens/automatic-ai_3.jpg';
import automaticAi_4 from '../../images/monitoringScreens/automatic-ai_4.jpg';
import './styles.scss';

const AutomaticAIMonitoring: FC = () => (
  <div className="content-wrapper">
    <PageHero
      title="Automatic AI monitoring"
      subtitle="Hexowatch will look for any types of changes (visual, content, HTML and technology monitoring)."
    />
    <Layout>
      <Section>
        <div className="col-lg-12 automatic-ai-onitoring">
          <iframe src="https://www.youtube.com/embed/D6-bij8ZQx8?rel=0"
            frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>

          <h2>Automatic AI monitor - Walkthrough</h2>
          <br />
          <div className="img-block">
            <img src={automaticAi_1} alt="Select automatic AI monitoring tool" />
          </div>
          <p className="mb">
            The automatic AI monitor keeps an eye for any changes on a page
            at a visual, content, HTML and technology level. This is ideal if
            you're looking for a quick way to check a page and want to get
            alerted when any type of change occurs.
          </p>

          <div className="img-block">
            <img src={automaticAi_2} alt="Preview desired URL" />
          </div>
          <p className="mb">
            To get started enter the url you want to check.
          </p>

          <div className="img-block">
            <img src={automaticAi_3} alt="Choose the frequency of the checks, your preferred notification channels" />
          </div>
          <p className="mb">
            Next, you can choose the frequency of the checks, your preferred
            notification channels, as well set custom start and end dates.
          </p>

          <div className="img-block">
            <img src={automaticAi_4} alt="Click start monitoring to get started" />
          </div>
          <p className="mb">
            Then click start monitoring to get started. Hexowatch will keep an
            eye on the page and will notify you when any changes are
            detected.
          </p>
        </div>
      </Section>
    </Layout>
  </div>
);

export default AutomaticAIMonitoring;
